import './Reset.css'
import Router from "./routes/Router";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
});


function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router/>
    </ThemeProvider>
    
  );
}

export default App;
